<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <Form ref="form" :model="formData" :rules="rule" :label-width="130">
                <FormItem :label="$t('new_password')" prop="user_pwd">
                    <Input v-model="formData.user_pwd" :placeholder="$t('input')" type="password"></Input>
                </FormItem>
                <FormItem :label="$t('fix_password')" prop="fix_password">
                    <Input v-model="formData.fix_password" :placeholder="$t('input')" type="password"></Input>
                </FormItem>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit">{{$t('save')}}</Button>
        </div>
    </div>
</template>

<script>
    export default {
        data:function(){
            return{
                relist: false,
                formData: {
                    u_id:'',
                    user_pwd: '',
                    fix_password: ''
                },
                rule: {
                    user_pwd: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    fix_password: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                }
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData.u_id = this.$base.getRequest().id;
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            submit: function(){

                var url = 'user/set-pwd-by-manage';
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        if(this.formData.fix_password != this.formData.user_pwd) {
                            this.$base.alertErr(this.$t('no_pwd'));
                            return;
                        }
                        this.formData.user_pwd = this.$base.toMD5(this.formData.user_pwd);
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.alertSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/user/user_reset_pwd.vue